export default __webpack_public_path__ + "static/lalibrairie-s-desktop@2x-840e6953635634d324f075be117ae705.jpg";